import { BrowserRouter as Router } from "react-router-dom";
import { ScrollToTop } from "./components/organims";
import Header from "./components/organims/Header";
import AppRoutes from "./navigation/routes";

function App() {
  // const { loading } = useIndicators();

  return (
    <Router>
      <ScrollToTop />
      {/* {loading ? (
        <Loader />
      ) : ( */}
      <Header>
        <AppRoutes />
      </Header>
      {/* )} */}
    </Router>
  );
}

export default App;
